import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'zh',
    size: Cookies.get('size') || 'mini', 
    cursystem: 0, 
    mainContainerSize: {height: '100%', width: '100%'}
  },
  mutations: {
    MAIN_CONTAINER_SIZE: (state, data) => { 
      state.mainContainerSize = data;
    },
    CUR_SYSTEM: (state, system) => {   
      state.cursystem = system; 
    },
    DISPLAY_MENU: (state, menuid) => {      
      state.sidebar.opened = true 
      console.log(['DISPLAY_MENU', state.sidebar.opened])
      Cookies.set('sidebarStatus', 0)
      state.sidebar.withoutAnimation = false
    },
    TOGGLE_SIDEBAR: state => {
      console.log(['TOGGLE_SIDEBAR1', state.sidebar.opened])
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      console.log(['TOGGLE_SIDEBAR2', Cookies.get('sidebarStatus')])
      state.sidebar.opened = !state.sidebar.opened
      console.log(['TOGGLE_SIDEBAR3', state.sidebar.opened])
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
      console.log(['CLOSE_SIDEBAR', state.sidebar.opened])
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    }
  },
  actions: { 
    setMainContainerSize({ commit }, data) {
      commit('MAIN_CONTAINER_SIZE', data)
    },
    setCurSystem({ commit }, { system }) {
      commit('CUR_SYSTEM', system)
    },
    displayMenu({ commit }, { menuid }) {
      commit('DISPLAY_MENU', menuid)
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js